import { useEffect, useState } from 'react'

export function useAboutViewModel({ repository }) {
  const [status, setStatus] = useState('idle')
  const [entries, setEntries] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    setStatus('loading')
    repository
      .fetchFAQEntries()
      .then((data) => {
        setEntries(data)
        setStatus('loaded')
      })
      .catch((err) => {
        setError(err.message ?? 'Failed to load FAQ')
        setStatus('failed')
      })
  }, [repository])

  return { status, entries, error }
}
